/*
 *   File : notification.js
 *   Author : https://evoqins.com
 *   Description : notification component
 *   Integrations : content/notification-list
 *   Version : 1.1.0
 */

import React, { useState, useEffect } from "react";
import { DataTableComponent } from "../../../../Components/DataTable";
import { PrimaryButton } from "../../../../Components/Buttons";
import { NotificationModal } from "../../../../Components/Modals";
import { Loader, EmptyScreen } from "../../../../Components/Other";
import { useDispatch } from "react-redux";
import { setPageTitle, setSearchEnabled } from "../../../../Redux/Ui/ui.slice";
import { APIService } from "../../../../Service";

export default function Notification() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle(["Manage Content"]));
    dispatch(setSearchEnabled(false));
  }, []);

  /* -----------------------------------
        STATE MANAGEMENT
  ----------------------------------- */
  const [modal, setModal] = useState(false);
  const [curNotification, setCurNotification] = useState({});
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [isEmpty, setIsEmpty] = useState(false);

  useEffect(() => {
    _getNotificationList();
  }, [page, perPage]);

  /* -----------------------------------
        API SERVICE
  ----------------------------------- */
  const _getNotificationList = () => {
    setLoader(true);

    const payload = {
      page: page,
      page_size: perPage,
    };

    APIService(true, "content/notification-list", payload)
      .then((res) => {
        if (res.status_code === 200) {
          const notifications = res.data?.data || [];
          console.log(notifications);
          setData(notifications);
          setTotalRows(res.data?.total_count || notifications.length);
          setIsEmpty(notifications.length === 0);
        } else {
          setData([]);
          setIsEmpty(true);
        }
      })
      .catch((err) => {
        console.error("Notification list error:", err);
        setData([]);
        setIsEmpty(true);
      })
      .finally(() => setLoader(false));
  };

  /* -----------------------------------
        TABLE COLUMNS
  ----------------------------------- */
  const COLUMNS = [
    {
      name: "Title",
      selector: (row) => row.title,
      wrap: true,
      width: "330px",
    },
    {
      name: "Target Users",
      selector: (row) => row.target_users,
      wrap: true,
    },
    {
      name: "Type",
      selector: (row) => row.type,
    },
    {
      name: "Sent On",
      selector: (row) => row.created,
    },
    {
      name: "Action",
      cell: (row) => (
        <PrimaryButton
          ClassName="bg-transparent fs-14 fw-500 text-facebook-blue p-0 rounded-0 e-border-bottom-dashed-blue"
          name="View"
          onPress={() => {
            setCurNotification(row);
            setModal(true);
          }}
        />
      ),
      button: true,
    },
  ];

  /* -----------------------------------
        RENDER
  ----------------------------------- */
  return (
    <div className="d-flex w-100 flex-column">
      {loader ? (
        <Loader />
      ) : isEmpty ? (
        <EmptyScreen message="No Notifications Found" />
      ) : (
        <DataTableComponent
          info={false}
          columns={COLUMNS}
          data={data}
          pagination={true}
          paginationServer={true}
          currentPage={page}
          paginationTotalRows={totalRows}
          paginationPerPage={perPage}
          onChangePage={(p) => setPage(p)}
          onChangeRowsPerPage={(newPerPage) => {
            setPerPage(newPerPage);
            setPage(1);
          }}
          className="e-table-basic"
        />
      )}
      <NotificationModal
        title={curNotification?.title}
        open={modal}
        time={"3m ago"}
        onCancel={() => setModal(false)}
        content={curNotification?.description}
      />
    </div>
  );
}
